import { useEffect } from 'react';

export function useRegisterInWindow(key: string, value: any) {
  useEffect(() => {
    (window as any)[`COTERA_${key}`] = value;

    return () => {
      (window as any)[`COTERA_${key}`] = null;
    };
  }, [value, key]);
}
